import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import store from '../store';
import { getToken } from '@/utils/auth';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 50000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['X-Token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  if (store.getters.isIdentityAuth) {
    config.headers['Authorization'] = 'Bearer ' + store.getters.oidcAccessToken;
  }
  const target_time = new Date('2026-02-28 8:00:00');
  // 计算目标时间对象到当前时间的毫秒数
  const reduce_ms = target_time.getTime() - Date.now();
  console.log('reduce_ms', reduce_ms);
  if (reduce_ms < 0) {
    if (config.url !== '/sysConf/isIdentityAuth') {
      Message({
        message: '系统已到期',
        type: 'error',
        duration: 10 * 1000
      });
      return null;
    }
  }

  return config;
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    const headers = response.headers;
    if (headers['content-type'] === 'application/vnd.ms-excel') {
      if (response.data.byteLength === 0) {
        Message({
          message: '暂无数据',
          type: 'warning',
          duration: 10 * 1000
        });
        return null;
      } else {
        return response;
      }
      //
    } else if (res.code !== 200) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('登录已超时，可以【取消】继续留在该页面，或者【重新登录】', '超时提醒', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload();// 为了重新实例化vue-router对象 避免bug
          });
        });
      } else {
        Message({
          message: res.message || res.msg,
          type: 'error',
          duration: 5 * 1000
        });
        return Promise.reject('error');
      }
      // return Promise.reject('error')
    } else {
      return response.data;
    }
  },
  error => {
    // console.log('err' + error)// for debug
    Message({
      message: '请求异常，请刷新本页面，异常详情：' + error.message,
      type: 'error',
      duration: 10 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
